import { render, staticRenderFns } from "./EditTagModal.vue?vue&type=template&id=d0701bca"
import script from "./EditTagModal.vue?vue&type=script&lang=js"
export * from "./EditTagModal.vue?vue&type=script&lang=js"
import style0 from "./EditTagModal.vue?vue&type=style&index=0&id=d0701bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports